import Cookies from "js-cookie";

import type { UserPreferences } from "~/components/userContext/context";

const PREFERENCES_COOKIE_KEY = "bp-classroom-preferences";

// Legacy key from beta
const PREFERENCES_COOKIE_KEY_OLD = "classroom.preferences";

/**
 * Gets the user's preferences from a cookie.
 */
export function getPreferences(): UserPreferences | null {
  const value = Cookies.get(PREFERENCES_COOKIE_KEY);
  return value ? JSON.parse(globalThis.atob(value)) : null;
}

/**
 * Sets the user's preferences in a cookie.
 */
export function setPreferences(raw: string) {
  const value = globalThis.btoa(raw);
  return Cookies.set(PREFERENCES_COOKIE_KEY, value, { expires: 365 });
}

/**
 * Clears the user's preferences by deleting the cookie.
 */
export function clearPreferences() {
  return Cookies.remove(PREFERENCES_COOKIE_KEY);
}

/**
 * Parsese a cookie string and returns the user's preferences.
 */
export function preferencesFromCookie(cookie: string): UserPreferences | null {
  const value = cookie
    .split("; ")
    ?.find(
      (x) =>
        x.split("=")[0] === PREFERENCES_COOKIE_KEY_OLD ||
        x.split("=")[0] === PREFERENCES_COOKIE_KEY,
    )
    ?.split("=")
    .slice(1)
    .join("=");

  return value ? JSON.parse(Buffer.from(value, "base64").toString()) : null;
}

/**
 * Migrates the user's preferences from the old cookie key to the new one.
 * TODO: Remove this function in Q3 2024.
 */
export function migratePreferences() {
  const old = Cookies.get(PREFERENCES_COOKIE_KEY_OLD);

  if (old) {
    Cookies.set(PREFERENCES_COOKIE_KEY, old, { expires: 365 });
    Cookies.remove(PREFERENCES_COOKIE_KEY_OLD);
  }
}
